import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M21.8579 7.702c.1647.5271-.1291 1.088-.6562 1.2527l-3.2 1c-.5272.1648-1.0881-.129-1.2528-.6562s.1291-1.088.6562-1.2527l3.2-1c.5272-.1647 1.0881.129 1.2528.6562m-.059 8.6178c-.1026.5698-.586.8887-1.0796.7122l-3.1713-1.134c-.4936-.1765-.8106-.7815-.7079-1.3513.1026-.5698.586-.8887 1.0796-.7122l3.1713 1.134c.4936.1765.8106.7815.7079 1.3513M17.9023 11c-.5522 0-1 .4477-1 1s.4478 1 1 1h2c.5523 0 1-.4477 1-1s-.4477-1-1-1z",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M16 5a1 1 0 0 0-1.7772-.6291c-1.0204 1.2604-3.0516 2.3852-5.3217 3.1625-2.2578.773-4.5063 1.1195-5.81 1.0002A1 1 0 0 0 2 9.5295v5.7647a1 1 0 0 0 1.2336.9723c.4808-.1155 1.078-.1451 1.7664-.0914V19.5c0 .5523.4477 1 1 1h3.5c.5523 0 1-.4477 1-1v-1.8363c1.7181.7154 3.1622 1.5301 3.8643 2.1083A.9999.9999 0 0 0 16 19.0001zM8.5026 16.9271c-.5042-.1617-1.0085-.3042-1.5026-.4216V18.5h1.5V17q0-.0368.0026-.0729M7 14.4558c.9563.2019 1.9329.4899 2.87.8224 1.509.5353 2.9736 1.2069 4.13 1.8635V7.2454c-1.3024.9176-2.8957 1.6476-4.451 2.1801A23.5 23.5 0 0 1 7 10.1407zm-2-3.9801a13.4 13.4 0 0 1-1 .0742v3.6072c.3266-.0142.6613-.0087 1 .013z",
        clipRule: "evenodd"
    }, "1")
], "AudienceCampaign", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
